module.exports = __webpack_public_path__ + "cce07a13a3b4ed89585ee352a79bb94c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_12.jpg
// module id = 1763
// module chunks = 5